/* Name:Chaitali Khachane
   Description:This is the pop-up page,this page will render once we click on Add new rule of configure Dq Rule page,
   this page will handle both column level rule and Asset level rule which we get from configure Dq rule file
   in this page we will allow user to fill details to onboard asset like asst name ,description,country ,region etc....
   on Click on submit button it will call submit API and clear all the form values
   or cancel button will discard all the filled value without saving it         
*/
import { Button } from "primereact/button"
import React, { Fragment, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import FormDropdown from "../../component/dropdown/formDropdown"
import ErrorMessage from "../../component/errorMessage/errorMsg"
import Forminputtext from "../../component/inputtext/forminputtext"
import PopUpScreen from "../../component/popUpScreen/popUpScreen"
import { FieldLabel } from "../global/global.style"
import { InputNumber } from 'primereact/inputnumber';
import { addNewAssetLevelRule, addNewColumnLevelRule } from "../../redux/dataAsset/dataAsset.action"
import { CLEAR_ALL_ERROR_MESSAGE, RESET_FORM_VALUE, SET_ERROR_MESSAGE, SET_FORM_OPTION, SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "../../redux/dataAsset/dataAsset.type"
import { LabelWrapper } from "../../component/inputtext/inputtextStyle"
import { Tooltip } from "primereact/tooltip"
import { theme } from "../../theme/theme"
import FormInputDescription from "../../component/inputtext/formInputDescription"
import { emptycheckFields } from "../../validator/pageValidation"
import { emptyErrorCheck } from "../../helpers/validation/emptyValidation"

function AddNewRule({ dataAssetId, ruleType, onHide, changeDetail }) {
    const { apiData, formData } = useSelector((state) => state.dataAsset)
    const dispatch = useDispatch()
    const restrictWords = (input) => {
        // Define the restricted words in a regular expression
        const restrictedWords = /\b(update|drop|delete|alter|INSERT|TRUNCATE)\b/i;
        // Check if the input contains any restricted words
        if (restrictedWords.test(input)) {
            console.log("Action restricted! The string contains a restricted word.");
            setErrorMessage("expression", "Modified queries are not allow.Plese re-enter expression")
            return false;  // Return false to indicate the action should be restricted
        } else {
            console.log("Action allowed. String is safe.");
            return true;  // Return true to indicate the action is allowed
        }
    }
    const duplicateCheck = (fieldType, value) => {
        switch (fieldType) {
            case "ruleName": {
                let isDuplicate = false
                setErrorMessage(fieldType, "")
                if (ruleType === "Column Level Rules") {
                    formData.configureColumnDQRuleform.options.map((val) => {
                        if (val.rules_name.toLowerCase() === value.toLowerCase()) {
                            setErrorMessage(fieldType, "An rule with this name already exits. Please choose a different name")
                            isDuplicate = true
                        }
                    })
                } else if (ruleType === "Asset Level Rules") {
                    formData.configureAssetDQRuleform.options.map((val) => {
                        if (val.rules_name.toLowerCase() === value.toLowerCase()) {
                            setErrorMessage(fieldType, "An rule with this name already exits. Please choose a different name")
                            isDuplicate = true
                        }
                    })
                }

                return isDuplicate
                // dispatch()
            }
            default: console.log(fieldType + " fieldType is not present")
        }
    }
    const duplicateDefaultCheck = (fieldType, value) => {
        switch (fieldType) {
            case "ruleName": {
                let isDuplicate = false
                // setErrorMessage(fieldType, "")
                if (ruleType === "Column Level Rules") {
                    formData.configureColumnDQRuleform.options.map((val) => {
                        if (val.rules_name.toLowerCase() === value.toLowerCase()) {
                            // setErrorMessage(fieldType, "An rule with this name already exits. Please choose a different name")
                            isDuplicate = true
                        }
                    })
                } else if (ruleType === "Asset Level Rules") {
                    formData.configureAssetDQRuleform.options.map((val) => {
                        if (val.rules_name.toLowerCase() === value.toLowerCase()) {
                            // setErrorMessage(fieldType, "An rule with this name already exits. Please choose a different name")
                            isDuplicate = true
                        }
                    })
                }

                return isDuplicate
                // dispatch()
            }
            default: console.log(fieldType + " fieldType is not present")
        }
    }
    const duplicateCheckCount = (fieldType, value) => {
        switch (fieldType) {
            case "ruleName": {
                let countIndex = 0
                if (ruleType === "Column Level Rules") {
                    formData.configureColumnDQRuleform.options.map((val) => {
                        if (val.rules_name.toLowerCase().includes(value.toLowerCase())) {
                            countIndex++
                        }
                    })
                } else if (ruleType === "Asset Level Rules") {
                    formData.configureAssetDQRuleform.options.map((val) => {
                        if (val.rules_name.toLowerCase().includes(value.toLowerCase()) ) {
                            countIndex++
                        }
                    })
                }
                return countIndex
                // dispatch()
            }

            default: console.log(fieldType + " fieldType is not present")
        }

    }
    const getColumnDimension = () => {
        let options = []
        formData.dimension.options.map((val) => {
            if (formData.check_type.options.filter((val1) => val1.dimension_name === val.name)[0]?.checks.column_level.length !== 0) {
                options.push(val)
            }
        })
        return options
    }
    //this method will call the redux and set the error message to the passed field
    const setErrorMessage = (fieldname, errorMessage) => {
        dispatch({
            type: SET_ERROR_MESSAGE,
            payload: {
                formField: fieldname,
                isError: true,
                errorMessage: errorMessage
            }
        })
    }
    const getAssetDimension = () => {
        let options = []
        formData.dimension.options.map((val) => {
            if (formData.check_type.options.filter((val1) => val1.dimension_name === val.name)[0].checks.asset_level.length !== 0) {
                options.push(val)
            }
        })
        return options
    }
    return <PopUpScreen style={{ width: "70%" }} header="Add New Rule" onHide={() => {
        dispatch({
            type: CLEAR_ALL_ERROR_MESSAGE
        })
        dispatch({
            type: RESET_FORM_VALUE
        })
        onHide()
    }}
    >
        {ruleType === "Column Level Rules" ? <Fragment>
            <div className="grid" >
                <div className="col-6" >
                    <div className="grid" >
                        <div className="col-6" >
                            <FormDropdown
                                style={{ width: "100%" }} options={formData.addColumns.options} filter optionLabel="attribute_name" placeholder="Select Column" label={<div>Column <span style={{ color: "#f10000" }}>* </span>
                                    <Tooltip target=".custom-target-icon" />
                                    <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                        data-pr-tooltip={"Select the column for which you want to apply the data quality rule."}
                                        data-pr-position="top"
                                        style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                    ></i>
                                </div>} name="addColumns" value={formData.addColumns.valueAsObj} required={false} onChange={(e) => changeDetail(e, "dropdown", e.target.value.attribute_name)}
                            />
                            <ErrorMessage message={formData.addColumns.errorMessage} />
                        </div>
                        <div className="col-6" >
                            <Forminputtext value={formData.addColumns.valueAsObj.attribute_datatype} disabled style={{ width: "100%", marginBottom: "8px", height: "40px" }} placeholder="Data Type" label="Data Type" />

                        </div>
                    </div>
                </div>
                <div className="col-6" >
                    <Tooltip target="#ruleName" />

                    <Forminputtext id="ruleName" style={{ width: "100%", marginBottom: "8px", height: "40px" }} placeholder="Rule Name" label={<div>Rule Name  <span style={{ color: "#f10000" }}>* </span><Tooltip target=".custom-target-icon" />
                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                            data-pr-tooltip={"Provide a unique name for the rule to help identify it."}
                            data-pr-position="top"
                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                        ></i>
                    </div>}
                        data-pr-tooltip={formData.ruleName.value}
                        name="ruleName"
                        value={formData.ruleName.value}
                        required={false}
                        onChange={(e) => {
                            duplicateCheck("ruleName", e.target.value)
                            changeDetail(e, "text")
                        }
                        }
                    />
                    <ErrorMessage message={formData.ruleName.errorMessage} />
                </div>
            </div>
            <div className="grid">
                <div className="col-6" >
                    <Forminputtext style={{ width: "100%", height: "40px" }} placeholder="Rule Description" label={<div>Rule Description <Tooltip target=".custom-target-icon" />
                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                            data-pr-tooltip={"Enter a brief description explaining the purpose and function of the rule."}
                            data-pr-position="top"
                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                        ></i>
                    </div>} name="ruleDescription" value={formData.ruleDescription.value} onChange={(e) => changeDetail(e, "text")} />
                    <ErrorMessage message={formData.ruleDescription.errorMessage} />

                </div>
                <div className="col-6" >
                    <FormDropdown
                        style={{ width: "100%" }}
                        options={getColumnDimension()}
                        optionLabel="name" placeholder="Select Dimension" label={<div>Dimension <span style={{ color: "#f10000" }}>* </span><Tooltip target=".custom-target-icon" />
                            <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                data-pr-tooltip={"Choose the data dimension that will be monitored for changes (e.g., completeness, uniqueness)."}
                                data-pr-position="top"
                                style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                            ></i>
                        </div>} name="dimension" valueAsObj={formData.dimension.valueAsObj} required={false} onChange={(e) => {
                            dispatch({
                                type: SET_FORM_VALUE,
                                payload: {
                                    formField: "ruleName",
                                    value: ""
                                }
                            })
                            if (formData.check_type.options.filter((val) => val.dimension_id === e.target.value.id)[0].checks.column_level.length === 1) {
                                dispatch({
                                    type: SET_FORM_VALUE,
                                    payload: {
                                        formField: "check_type",
                                        value: formData.check_type.options.filter((val) => val.dimension_id === e.target.value.id)[0].checks.column_level[0].check_name
                                    }
                                })
                                if (duplicateDefaultCheck("ruleName", apiData.assetSummary.data.data_asset_name + "_" + formData.addColumns.value + "_" + formData.check_type.options.filter((val) => val.dimension_id === e.target.value.id)[0].checks.column_level[0].check_name)) {
                                    dispatch({
                                        type: SET_FORM_VALUE,
                                        payload: {
                                            formField: "ruleName",
                                            value: apiData.assetSummary.data.data_asset_name + "_" + formData.addColumns.value + "_" + formData.check_type.options.filter((val) => val.dimension_id === e.target.value.id)[0].checks.column_level[0].check_name + "_" + duplicateCheckCount("ruleName", apiData.assetSummary.data.data_asset_name + "_" + formData.addColumns.value + "_" + formData.check_type.options.filter((val) => val.dimension_id === e.target.value.id)[0].checks.column_level[0].check_name)
                                        }
                                    })
                                } else {
                                   
                                    dispatch({
                                        type: SET_FORM_VALUE,
                                        payload: {
                                            formField: "ruleName",
                                            value: apiData.assetSummary.data.data_asset_name + "_" + formData.addColumns.value + "_" + formData.check_type.options.filter((val) => val.dimension_id === e.target.value.id)[0].checks.column_level[0].check_name
                                        }
                                    })
                                }
                              
                                dispatch({
                                    type: SET_FORM_VALUE,
                                    payload: {
                                        formField: "expression",
                                        value: ""
                                    }
                                })
                                dispatch({
                                    type: SET_FORM_VALUEOBJ,
                                    payload: {
                                        formField: "check_type",
                                        valueAsObj: formData.check_type.options.filter((val) => val.dimension_id === e.target.value.id)[0].checks.column_level[0]
                                    }
                                })
                            } else {
                                dispatch({
                                    type: SET_FORM_VALUE,
                                    payload: {
                                        formField: "check_type",
                                        value: ""
                                    }
                                })
                                dispatch({
                                    type: SET_FORM_VALUEOBJ,
                                    payload: {
                                        formField: "check_type",
                                        valueAsObj: {}
                                    }
                                })
                            }


                            changeDetail(e, "dropdown", e.target.value.name)
                        }}
                    />
                    <ErrorMessage message={formData.dimension.errorMessage} />
                </div>
            </div>
            <div className="grid">
                <div className="col-6" >
                    <div className="grid">

                        <div className="col-6" >
                            <FormDropdown
                                style={{ width: "100%" }} options={Object.keys(formData.dimension.valueAsObj).length === 0 ? [] : formData.check_type.options.filter((val) => val.dimension_id === formData.dimension.valueAsObj.id)[0].checks.column_level} optionLabel="check_name" placeholder="Select Check Type" label={<div>Check Type<span style={{ color: "#f10000" }}>* </span><Tooltip target=".custom-target-icon" />
                                    <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                        data-pr-tooltip={"Select the type of check to apply (e.g., anomaly detection, range validation)."}
                                        data-pr-position="top"
                                        style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                    ></i>
                                </div>}
                                name="check_type" valueAsObj={formData.check_type.valueAsObj} required={false} onChange={(e) => {
                                    changeDetail(e, "dropdown", e.target.value.check_name)

                                    dispatch({
                                        type: SET_FORM_OPTION,
                                        payload: {
                                            formField: "dataAssetChecks",
                                            data: e.target.value.check_mapping === "DISABLED" ? [] : e.target.value.check_mapping.split(',')
                                        }
                                    })
                                    if (duplicateDefaultCheck("ruleName", apiData.assetSummary.data.data_asset_name + "_" + formData.addColumns.value + "_" + e.target.value.check_name)) {
                                        dispatch({
                                            type: SET_FORM_VALUE,
                                            payload: {
                                                formField: "ruleName",
                                                value: apiData.assetSummary.data.data_asset_name + "_" + formData.addColumns.value + "_" + e.target.value.check_name + "_" + duplicateCheckCount("ruleName", apiData.assetSummary.data.data_asset_name + "_" + formData.addColumns.value + "_" + e.target.value.check_name)
                                            }
                                        })
                                    } else {
                                        dispatch({
                                            type: SET_FORM_VALUE,
                                            payload: {
                                                formField: "ruleName",
                                                value: apiData.assetSummary.data.data_asset_name + "_" + formData.addColumns.value + "_" + e.target.value.check_name
                                            }
                                        })
                                    }
                                }}
                            />
                            <ErrorMessage message={formData.check_type.errorMessage} />
                        </div>
                        <div className="col-6" >
                            <FormDropdown
                                disabled={formData.check_type.valueAsObj.check_mapping === "DISABLED"}
                                style={{ width: "100%" }} options={formData.dataAssetChecks.options} optionLabel="name" placeholder="Select Check" label={<div>Check
                                    <Tooltip target=".custom-target-icon" />
                                </div>}
                                name="dataAssetChecks" valueAsObj={formData.dataAssetChecks.valueAsObj} required={false} onChange={(e) => {
                                    changeDetail(e, "dropdown", e.target.value)
                                }}
                            />
                            <ErrorMessage message={formData.dataAssetChecks.errorMessage} />
                        </div>
                    </div>
                </div>
                <div className="col-6" >
                    <Forminputtext
                        disabled={formData.dimension.value === "drift" || (formData.dimension.value === "uniqueness" && formData.check_type.value === "duplicate_check") || (formData.dimension.value === "completeness" && formData.check_type.value === "null_check")} style={{ width: "100%", marginBottom: "8px", height: "40px" }} placeholder="Expression" label={<div>Expression <Tooltip target=".custom-target-icon" />
                            <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                data-pr-tooltip={"Specify the acceptable values for the selected column to maintain data consistency."}
                                data-pr-position="top"
                                style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                            ></i>
                        </div>} name="validValues" value={formData.validValues.value} required={false} onChange={(e) => changeDetail(e, "text")} />
                    <ErrorMessage message={formData.validValues.errorMessage} />
                </div>
            </div>
            <div className="grid">
                <div className="col-6" >
                    <div className="grid">
                        <div className="col-6" >
                            <FormDropdown disabled={formData.dimension.value !== "drift"} style={{ width: "100%" }} options={formData.drift_type.options} optionLabel="name" placeholder="Drift Type" label={<div>Drift Type

                            </div>} name="drift_type" valueAsObj={formData.drift_type.valueAsObj} onChange={(e) => changeDetail(e, "dropdown", e.target.value.name)} />
                            <ErrorMessage message={formData.drift_type.errorMessage} />
                        </div>
                        <div className="col-6" >
                            {formData.drift_type.valueAsObj.name === "Percentage" ? <Fragment><label htmlFor="driftper" >
                                <LabelWrapper>
                                    <FieldLabel>Drift Value
                                        <Tooltip target=".custom-target-icon" />
                                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                            data-pr-tooltip={"Define the allowable percentage change in data distribution before triggering an alert."}
                                            data-pr-position="top"
                                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                        ></i>
                                    </FieldLabel>
                                </LabelWrapper>
                            </label>
                                <InputNumber
                                    disabled={formData.dimension.value !== "drift"}
                                    inputId="driftper"
                                    name="driftPercentage"
                                    value={formData.driftPercentage.value}
                                    onValueChange={(e) => changeDetail(e, "number", e.value)}
                                    // showButtons
                                    step={1}
                                    min={0}
                                    max={100}
                                    style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                                /></Fragment> : <Fragment>
                                <LabelWrapper>
                                    <FieldLabel>Drift Value
                                        <Tooltip target=".custom-target-icon" />
                                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                            data-pr-tooltip={"Specify the expected or allowable drift value to monitor changes in data patterns."}
                                            data-pr-position="top"
                                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                        ></i>
                                    </FieldLabel>
                                </LabelWrapper>
                                <InputNumber
                                    disabled={formData.dimension.value !== "drift"}
                                    name="driftValue"
                                    value={formData.driftValue.value}
                                    onValueChange={(e) => changeDetail(e, "number", e.value)}
                                    // showButtons
                                    step={1}
                                    min={0}
                                    style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                                />
                                <ErrorMessage message={formData.driftValue.errorMessage} />
                            </Fragment>}
                        </div>
                    </div>
                </div>
                <div className="col-6" >
                    <label htmlFor="driftwindow" >
                        <LabelWrapper>
                            <FieldLabel>Drift Window (in days)
                                <Tooltip target=".custom-target-icon" />
                                <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                    data-pr-tooltip={"Set the time window (in days) over which data drift will be evaluated."}
                                    data-pr-position="top"
                                    style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                ></i>
                            </FieldLabel>
                        </LabelWrapper>
                    </label>
                    <InputNumber
                        disabled={formData.dimension.value !== "drift"}
                        inputId="driftwindow"
                        value={formData.driftWindow.value}
                        name="driftWindow"
                        onValueChange={(e) => changeDetail(e, "number", e.value)}
                        showButtons
                        step={1}
                        min={0}
                        max={100}
                        style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                    />
                </div>
            </div>
            <div className="grid">

                <div className="col-6" >
                    <FormDropdown
                        disabled={formData.dimension.value === "drift" || (formData.dimension.value === "validity" && (formData.check_type.value === "date_format_check" || formData.check_type.value === "datetime_format_check" || formData.check_type.value === "email_validation_check" ))}
                        style={{ width: "100%" }} options={formData.threshold_type.options} optionLabel="name" placeholder="Threshold Type" label={<div>Threshold Type<Tooltip target=".custom-target-icon" />
                            <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                data-pr-tooltip={"Select the type of threshold (e.g., count, percentage) to define the acceptable limits."}
                                data-pr-position="top"
                                style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                            ></i>
                        </div>} name="threshold_type" valueAsObj={formData.threshold_type.valueAsObj} required={false} 
                        onChange={(e) =>
                        {
                          
                            if (e.value.name === 'Percentage') {
                          
                                changeDetail({target:{name:'threshold'}}, "number", 0); 
                        }
                        changeDetail(e, "dropdown", e.target.value.name)}
                            }
                    />
                    <ErrorMessage message={formData.threshold_type.errorMessage} />
                </div>
                <div className="col-6" >
                    <label htmlFor="threshold" > <LabelWrapper><FieldLabel>Threshold
                        <Tooltip target=".custom-target-icon" />
                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                            data-pr-tooltip={" Enter the threshold value that determines acceptable variance for the rule."}
                            data-pr-position="top"
                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                        ></i>

                    </FieldLabel></LabelWrapper></label>

                    <InputNumber
                        disabled={formData.threshold_type.value === "" || formData.threshold_type.value === null || formData.dimension.value === "drift" || (formData.dimension.value === "validity" && (formData.check_type.value === "date_format_check" || formData.check_type.value === "datetime_format_check" || formData.check_type.value === "email_validation_check"))}
                        inputId="threshold"
                        value={formData.threshold.value}
                        name="threshold"
                        onKeyDown={(e) => {
                            if (formData?.threshold_type?.value === 'Percentage') {
                                const newValue = parseInt(e.target.value + e.key);
                                if (newValue > 100) {
                                    changeDetail(e, "number", 100);
                                    e.preventDefault()
                                }; // Stops input if above 100
                            }
                        }}
                        onChange={(e) => {
                            let newValue = e.value; 
                            changeDetail(e.originalEvent, "number", newValue);
                        }} showButtons
                        step={1}
                        min={0}
                        max={formData?.threshold_type?.value==='Percentage'?100:Infinity}
                        style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                    />


                </div>
            </div>
        </Fragment> : ruleType === "Asset Level Rules" ? <Fragment>
            <div className="grid">
                <div className="col-6" >
                    <FormDropdown
                        style={{ width: "100%" }} options={getAssetDimension()} optionLabel="name" placeholder="Select Dimension" label={<div>Dimension <span style={{ color: "#f10000" }}>* </span><Tooltip target=".custom-target-icon" />
                            <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                data-pr-tooltip={"Choose the data dimension that will be monitored for changes (e.g., completeness, uniqueness)."}
                                data-pr-position="top"
                                style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                            ></i>
                        </div>} name="dimension" valueAsObj={formData.dimension.valueAsObj} required={false} onChange={(e) => {
                            dispatch({
                                type: SET_FORM_VALUE,
                                payload: {
                                    formField: "check_type",
                                    value: ""
                                }
                            })
                            dispatch({
                                type: SET_FORM_VALUEOBJ,
                                payload: {
                                    formField: "check_type",
                                    valueAsObj: {}
                                }
                            })
                            dispatch({
                                type: SET_FORM_VALUE,
                                payload: {
                                    formField: "expression",
                                    value: ""
                                }
                            })
                            changeDetail(e, "dropdown", e.target.value.name)
                        }}
                    />
                    <ErrorMessage message={formData.dimension.errorMessage} />
                </div>
                <div className="col-6" >
                    <div className="grid">
                        <div className="col-6" >
                            <FormDropdown
                                style={{ width: "100%" }} options={Object.keys(formData.dimension.valueAsObj).length === 0 ? [] : formData.check_type.options.filter((val) => val.dimension_id === formData.dimension.valueAsObj.id)[0].checks.asset_level} optionLabel="check_name" placeholder="Select Check" label={<div>Check <span style={{ color: "#f10000" }}>* </span><Tooltip target=".custom-target-icon" />
                                    <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                        data-pr-tooltip={"Select the type of check to apply (e.g., anomaly detection, range validation)."}
                                        data-pr-position="top"
                                        style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                    ></i>
                                </div>} name="check_type" valueAsObj={formData.check_type.valueAsObj} required={false} onChange={(e) => {
                                   
                                       if (duplicateDefaultCheck("ruleName", apiData.assetSummary.data.data_asset_name + "_" + e.target.value.check_name)) {                                        
                                        dispatch({                                           
                                        type: SET_FORM_VALUE,
                                            payload: {
                                                formField: "ruleName",
                                                value: apiData.assetSummary.data.data_asset_name + "_" + e.target.value.check_name + "_" + duplicateCheckCount("ruleName",  apiData.assetSummary.data.data_asset_name + "_" + e.target.value.check_name)
                                                // value: apiData.assetSummary.data.data_asset_name + "_" + formData.addColumns.value + "_" + e.target.value.check_name + "_" + duplicateCheckCount("ruleName", apiData.assetSummary.data.data_asset_name + "_" + formData.addColumns.value + "_" + e.target.value.check_name)
                                            }
                                        })
                                    } else {
                                        dispatch({
                                            type: SET_FORM_VALUE,
                                            payload: {
                                                formField: "ruleName",
                                                value: apiData.assetSummary.data.data_asset_name + "_" + e.target.value.check_name
                                            }
                                        })
                                    }

                                    changeDetail(e, "dropdown", e.target.value.check_name)
                                }}
                            />
                            <ErrorMessage message={formData.check_type.errorMessage} />

                        </div>
                        <div className="col-6" >
                            <Forminputtext style={{ width: "100%", height: "40px" }} placeholder="Rule Name" label={<div>Rule Name
                            </div>} name="ruleDescription" value={formData.ruleName.value} />
                            <ErrorMessage message={formData.ruleName.errorMessage} />
                        </div>
                    </div>

                </div>
            </div>
            <div className="grid">

                <div className="col-6" >
                    <Forminputtext style={{ width: "100%", height: "40px" }} placeholder="Rule Description" label={<div>Rule Description<Tooltip target=".custom-target-icon" />
                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                            data-pr-tooltip={"Enter a brief description explaining the purpose and function of the rule."}
                            data-pr-position="top"
                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                        ></i>
                    </div>} name="ruleDescription" value={formData.ruleDescription.value} onChange={(e) => changeDetail(e, "text")} />
                    <ErrorMessage message={formData.ruleDescription.errorMessage} />
                    <div className="grid" style={{ marginTop: "2px" }}>
                        <div className="col-6" >
                            <FormDropdown
                                disabled={formData.dimension.value !== "drift"}
                                style={{ width: "100%" }} options={formData.drift_type.options} optionLabel="name" placeholder="Drift Type" label={<div>Drift Type

                                </div>} name="drift_type" valueAsObj={formData.drift_type.valueAsObj} onChange={(e) => changeDetail(e, "dropdown", e.target.value.name)} />
                            <ErrorMessage message={formData.drift_type.errorMessage} />
                        </div>
                        <div className="col-6" >
                            {formData.drift_type.valueAsObj.name === "Percentage" ? <Fragment><label htmlFor="driftper" >
                                <LabelWrapper>
                                    <FieldLabel>Drift Value
                                        <Tooltip target=".custom-target-icon" />
                                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                            data-pr-tooltip={"Define the allowable percentage change in data distribution before triggering an alert."}
                                            data-pr-position="top"
                                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                        ></i>
                                    </FieldLabel>
                                </LabelWrapper>
                            </label>
                                <InputNumber
                                    disabled={formData.dimension.value !== "drift"}
                                    inputId="driftper"
                                    name="driftPercentage"
                                    value={formData.driftPercentage.value}
                                    onValueChange={(e) => changeDetail(e, "number", e.value)}
                                    // showButtons
                                    step={1}
                                    min={0}
                                    max={100}
                                    style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                                /></Fragment> : <Fragment>
                                <LabelWrapper>
                                    <FieldLabel>Drift Value
                                        <Tooltip target=".custom-target-icon" />
                                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                            data-pr-tooltip={"Specify the expected or allowable drift value to monitor changes in data patterns."}
                                            data-pr-position="top"
                                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                        ></i>
                                    </FieldLabel>
                                </LabelWrapper>
                                <InputNumber
                                    disabled={formData.dimension.value !== "drift"}
                                    name="driftValue"
                                    value={formData.driftValue.value}
                                    onValueChange={(e) => changeDetail(e, "number", e.value)}
                                    // showButtons
                                    step={1}
                                    min={0}
                                    style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                                />
                                <ErrorMessage message={formData.driftValue.errorMessage} />
                            </Fragment>}

                        </div>
                    </div>
                    <label htmlFor="driftwindow" >
                        <LabelWrapper>
                            <FieldLabel>Drift Window (in days)
                                <Tooltip target=".custom-target-icon" />
                                <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                    data-pr-tooltip={"Set the time window (in days) over which data drift will be evaluated."}
                                    data-pr-position="top"
                                    style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                ></i>
                            </FieldLabel>
                        </LabelWrapper>
                    </label>
                    <InputNumber
                        disabled={formData.dimension.value !== "drift"}
                        inputId="driftwindow"
                        value={formData.driftWindow.value}
                        name="driftWindow"
                        onValueChange={(e) => changeDetail(e, "number", e.value)}
                        showButtons
                        step={1}
                        min={0}
                        max={100}
                        style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                    />
                </div>
                <div className="col-6" >
                    <Fragment><FormInputDescription
                        disabled={
                            (
                                formData.dimension.valueAsObj.name === "validity" &&
                                formData.check_type.valueAsObj.check_name === "custom_sql_check"
                            ) ||
                                (
                                    formData.dimension.valueAsObj.name === "consistency" &&
                                    formData.check_type.valueAsObj.check_name === "schema_check"
                                )
                                ? false
                                : true
                        } placeholder="Write Expression..." style={{ width: "100%", height: "89%" }} label={<div>Expression<Tooltip target=".custom-target-icon" />
                            <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                data-pr-tooltip={"Specify the acceptable values for the selected column to maintain data consistency."}
                                data-pr-position="top"
                                style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                            ></i>
                        </div>} name="expression" value={formData.expression.value} onChange={(e) => changeDetail(e, "text")} />
                        <ErrorMessage message={formData.expression.errorMessage} /></Fragment>

                </div>
            </div>
        </Fragment> : ""
        }

        <div className="grid" style={{ marginTop: "10px" }}>
            <div className="col-12" style={{ marginTop: "10px", textAlign: "right" }} >
                <Button style={{ width: "100px", textAlign: "center", marginRight: "10px" }} outlined label="Cancel" onClick={() => {
                    dispatch({
                        type: RESET_FORM_VALUE
                    })
                    dispatch({
                        type: CLEAR_ALL_ERROR_MESSAGE
                    })
                    onHide()
                }} />
                <Button style={{ width: "100px", textAlign: "center" }} label="Save" onClick={() => {
                    if (ruleType === "Column Level Rules") {
                        dispatch({
                            type: CLEAR_ALL_ERROR_MESSAGE
                        })
                        if (emptyErrorCheck(emptycheckFields.newColumnRule, formData, setErrorMessage).length > 0 || duplicateCheck("ruleName", formData.ruleName.value)) {
                        } else {
                            dispatch(addNewColumnLevelRule(dataAssetId))
                            dispatch({
                                type: RESET_FORM_VALUE
                            })
                            onHide()
                        }


                    } else if (ruleType === "Asset Level Rules") {
                        if (emptyErrorCheck(emptycheckFields.newAssetRule, formData, setErrorMessage).length > 0 || restrictWords(formData.expression.value) === false) {
                        } else {
                            dispatch({
                                type: CLEAR_ALL_ERROR_MESSAGE
                            })
                            dispatch(addNewAssetLevelRule(dataAssetId))
                            dispatch({
                                type: RESET_FORM_VALUE
                            })
                            onHide()
                        }
                    }

                }} />

            </div>
        </div>
    </PopUpScreen>
}
export default AddNewRule